import React, { useState } from "react";
import { Button } from "./wrapper";
import Select from "react-select";
import _ from "lodash";

export const optionsEmail = [
  {
    label: "ทั้งหมด",
    value: "ALL",
  },
  {
    label: "ส่งอีเมล",
    value: "1",
  },
  {
    label: "ส่งจดหมาย",
    value: "2",
  },
];

function FilterEmail({
  oriLoan = [],
  setLoan,
  selectOption: selectGlobalOption,
  setSelectOption: setSelectGlobalOption,
}) {
  const [selectOption, setSelectOption] = useState(optionsEmail[0]);

  const onChangeSelect = (select) => {
    setSelectOption(select);
    setSelectGlobalOption(select);

    setLoan((prev) => {
      let newTemp = [...oriLoan];

      if (select?.value === "ALL") {
        return [...newTemp];
      }

      newTemp = newTemp
        .map((item) => {
          if (item?.letter === select?.value) {
            return { ...item };
          }
          return null;
        })
        .filter((temp) => temp);

      return newTemp;
    });
  };

  return (
    <div className="flex">
      <Select
        className=" w-40"
        onChange={onChangeSelect}
        options={optionsEmail}
        value={selectOption}
      />
    </div>
  );
}

export default FilterEmail;
